<template>
  <v-container>
    <h1>Update Geotag statistic</h1>

    <progress-component script="GeotagCheck"></progress-component>
  </v-container>
</template>

<script>
import ProgressComponent from '../components/ProgressComponent.vue';

export default {
  name: 'UpdateGeotagStatistic',
  components: { ProgressComponent },
};
</script>
